import React from 'react';
import { ButtonGroup } from 'reactstrap';

import DeleteButton from './DeleteButton';
import DownloadButton from './DownloadButton';

export default onDeleteCreative => ({
  Header: '',
  key: 'download',
  accessor: 'id',
  Cell: row => {
    const { name, id } = row.original;
    return (
      <ButtonGroup>
        <DownloadButton id={id} fileName={name} />
        <DeleteButton onDeleteCreative={onDeleteCreative} id={id} />
      </ButtonGroup>
    );
  },
  width: 67,
  filterable: false,
});
